import React from 'react'
import Card from '../Card'
import s1 from '../../assets/img/service1.png'
import s2 from '../../assets/img/service2.png'
import s3 from '../../assets/img/service3.png'
import vector from '../../assets/img/icon/Vector.png'
import bg from '../../assets/img/bg-pattern.png'
const data2 = [
  {
    title: 'Эсийн банк',
    image: s1,
    nav: 'cellbank',
    desc: 'Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах боломжтой. Манай эмнэлэг хүйн цуснаас болон хүйн эдээс үүдэл эсийг өндөр технологиор ялган авч, олон жилийн туршид чанарын алдагдалгүй хадгалах нөхцөлийг бүрдүүлдэг.'
  },
  {
    title: 'Эсийн эмчилгээ',
    image: s2,
    nav: 'therapy',
    desc: 'Хүний биеийн бүтэц, үйл ажиллагааны үндсэн нэгж болох эс нь байгалиас заяасан орлуулшгүй үнэтэй эмчилгээний эх үүсвэр юм. Эсийн эмчилгээ нь хавдар, аутоиммун өвчин, эрхтэн шилжүүлэн суулгалтын дараах дархлаа зохицуулалт, хөгшрөлтийн эсрэг үйлчилгээ, шархны эдгэрэлтийг хурдасгах болон нөхөн сэргээх анагаах ухааны гол түлхүүр болж байна.'
  },
  {
    title: 'Генетик шинжилгээ',
    image: s3,
    nav: 'genetic',
    desc: 'Генетикийн шинжилгээ хийлгэснээр та өөрийн болон гэр бүлийнхээ эрүүл мэндийг урьдчилан хамгаалах боломжтой.'
  }
]

const ServicesSection = () => {
  return (
    <div
    //  className='bg-gradient-to-r from-[#08273D] to-[#89D4E5] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)] '
    >
      <div   style={{
        backgroundImage: ` url("${bg}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        // height: '100vh', 
      }}>
        <section
          id='about'
          className='relative h-[100vh] short-screen mobile:h-full mask-cover mask-repeat md:h-auto p-20 flex flex-col justify-center
         maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto
         mobile:p-5 tablet:p-5'
          style={{
            WebkitMaskRepeat: 'repeat'
          }}
        >
          <div className='flex flex-row items-center mobile:justify-between text-white mobile:text-[10px] h-[5vh]'>
            <p className='text-[18px] text-white/55 mobile:text-[10px]'>
              02 / 06
            </p>
            <p className='ml-8 mobile:ml:0 text-white/55 gap-2 '>|</p>
            <p className='ml-8 mobile:ml:0 uppercase text-[36px] font-bold mobile:text-[16px] tablet:text-[28px]'>
              Үйлчилгээнүүд
            </p>
            <div className='flex flex-row items-center'>
              {/* <p className='ml-8 mobile:ml:0 text-white/55 text-[14px] mobile:text-[10px]'>
                Бүгдийг үзэх
              </p> */}
              <img src={vector} alt='vec' className='ml-[10px] mobile:hidden' />
            </div>
          </div>
          <div 
          className='flex flex-row justify-between items-center h-[60vh] short-screen mt-5 md:flex-row mobile:flex-col gap-16 mobile:h-full   tablet:flex-col tablet:h-full tablet:p-20'
          >
            {data2.map(item => (
              <Card data={item} key={item.title}></Card>
            ))}
          </div>
        </section>
      </div>
    </div>
  )
}

export default ServicesSection
